/* src/app/core/widgets/grid/grid.component.scss */
.gridContainer {
  width: 100%;
}
.gridContainer .gridStatusLine {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.gridContainer .gridStatusLine .resultsPerPageSelect {
  width: 5rem;
  display: inline-block;
}
.gridContainer .gridPagination {
  width: 100%;
}
.gridContainer .gridPagination ul {
  display: table;
  margin: 0 auto;
  list-style-type: none;
}
.gridContainer .gridPagination li {
  display: inline-block;
  margin: 0 0.15rem;
}
.gridContainer .gridPagination li .btn-secondary {
  box-shadow: none !important;
}
.gridContainer .gridPagination li .btn-secondary.active {
  background: #006498 !important;
  border-color: #006498 !important;
  color: #fff !important;
}
.searchFiltersContainer {
  padding: 1rem 1.25rem;
  background: white;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  margin-bottom: 1rem;
}
.searchFiltersContainer h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1e293b;
}
.searchFiltersContainer h4 {
  margin: 0 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}
.searchToolbarHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}
.searchSection {
  margin-bottom: 0.9rem;
}
.searchSection:last-child {
  margin-bottom: 0;
}
.savedSearchRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.savedSearchRow .savedSearchSelect {
  width: 18rem;
  max-width: 100%;
}
.filterRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.filterRow:last-child {
  margin-bottom: 0;
}
.filterRow select,
.filterRow input {
  flex: 1 1 10rem;
  min-width: 8rem;
}
.filterRow .filterRowBtn {
  flex: 0 0 auto;
  width: 2.5rem;
  padding-left: 0;
  padding-right: 0;
}
.quickSearchBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
.quickSearchLabel {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  flex: 0 0 auto;
}
.quickSearchActions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 0 0 auto;
}
.quickSearchInputGroup {
  flex: 1 1 16rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.4rem 0.85rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
}
.quickSearchInputGroup i {
  color: #94a3b8;
  font-size: 0.85rem;
}
.quickSearchInputGroup input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.9rem;
}
.dateToolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}
.gridTableCard {
  background: white;
  padding: 1rem 1.25rem 1.25rem;
  border-radius: 0.6rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gridToolbar {
  margin-bottom: 0.75rem;
}
.toolbar-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}
th.inverse a {
  color: #666;
}
.gridEmptyRow td {
  border-top: none;
}
.gridEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 1rem;
  color: #94a3b8;
  text-align: center;
}
.gridEmptyState i {
  font-size: 1.75rem;
}
.gridEmptyState p {
  margin: 0;
  font-size: 0.9rem;
}
.datePicker {
  display: inline-block;
  position: absolute;
  left: 50rem;
  top: 35rem;
}
/*# sourceMappingURL=grid.component.css.map */
